/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const localisationSchema = z.object({
      "numeroRue": z.string().describe("Numéro de rue du bien").optional(),
  "adresse": z.string().describe("Adresse du bien").optional(),
  "codePostal": z.string().describe("Code postal du bien").optional(),
  "commune": z.string().describe("Commune du bien").optional()
      })